import { Auth } from '@justgiving/auth';
import { captureException, configureScope } from '@sentry/browser';
import { v4 as uuidv4, v5 as uuidv5 } from 'uuid';

let refreshingAccessToken: any = null;
let refreshTokensUsed: Record<string, number> = {};

const hashUuid = uuidv4();
export const fetchWithTokenRefresh = async (
  auth: Auth,
  input: RequestInfo,
  init?: RequestInit,
) => {
  if (auth.isUserLoggedIn()) {
    try {
      if (!refreshingAccessToken) {
        const refreshToken = auth.getRefreshToken();
        const hashedRefreshToken = refreshToken
          ? uuidv5(refreshToken, hashUuid)
          : 'unknown';
        const currentCount = refreshTokensUsed[hashedRefreshToken] ?? 0;
        refreshTokensUsed[hashedRefreshToken] = currentCount + 1;
        refreshingAccessToken = auth.refreshAccessTokenIfExpired();
      }
      await refreshingAccessToken;
    } catch (error) {
      configureScope(scope => {
        scope.setExtras(refreshTokensUsed);
        captureException(error);
      });
    }
    refreshingAccessToken = null;
  }

  return fetch(input, init);
};
